import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";
import { MessageGearsService } from "./MessageGearsService";
import { CampaignDBService } from "./CampaignDBService";
export class JoinEmailModule extends Component {
	form: HTMLFormElement;
	titleElem: HTMLElement;
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		this.form = this._element.querySelector("form") as HTMLFormElement;
		this.titleElem = this._element.querySelector(".title") as HTMLElement;

		if (!this.form) {
			throw new Error("New form element found in component");
		}

		this.applyValidations();
		// Justication: adding an evtListener - not waiting for complete
		// tslint:disable-next-line: no-floating-promises
		this.handleSubmit();
	}

	applyValidations(): void {
		const errorClass = "hasError";
		const { errorMessageEmail } = this._element.dataset;
		$(this.form).validate({
			errorClass,
			errorPlacement: (error, element) => {
				error.appendTo(element.parent().siblings(".error-container"));
			},
			highlight: element => {
				$(element).parent().addClass(errorClass);
			},
			messages: {
				email: {
					email: errorMessageEmail ?? "Please enter valid email address",
					required: errorMessageEmail ?? "Please enter valid email address"
				}
			},
			rules: {
				email: {
					email: true,
					required: true
				}
			},
			unhighlight: element => {
				$(element).parent().removeClass(errorClass);
			}
		});
	}

	async handleSubmit(): Promise<void> {
		this.form.addEventListener("submit", async e => {
			e.preventDefault();
			const isFormValid = $(this.form).valid();
			if (isFormValid) {
				await this.saveEmailToDb();
				// TODO: handle response based on db writing
				const jwtToken = await this.fetchJWT();
				console.log({ jwtToken });
				if (jwtToken) {
					await this.submitForm(jwtToken);
					this.toggleSubmitDisplay();
				}
			}
		});
	}

	async saveEmailToDb(): Promise<{} | undefined> {
		const { dbEndpoint: endpoint } = this._element.dataset;
		const email = this.getEmailFormVal();

		if (!endpoint || !email) {
			throw new Error("Missing email field and/or database endpoint value.");
		}

		const response: {} = CampaignDBService.sendEmailToDb(endpoint, email);
		if (!response) {
			this.toggleAPIErrorMsg();

			return;
		}

		return response;
	}

	async fetchJWT(): Promise<string | undefined> {
		const { endpoint, payload } = this.getJWTReqItems();
		const jwtToken:
			| { token?: string }
			| undefined = await MessageGearsService.getJWTToken(endpoint, payload);

		if (!jwtToken || !jwtToken?.token) {
			this.toggleAPIErrorMsg();

			return;
		}

		return jwtToken.token;
	}

	toggleAPIErrorMsg(msg?: string): void {
		const { errorMessageApi } = this._element.dataset;
		if (!errorMessageApi) {
			console.warn("No API error message provided. Please check field.");

			return;
		}
		const validator = $(this.form).validate();
		validator.showErrors({
			email: msg ? msg : errorMessageApi
		});
	}

	async submitForm(jwtToken: string): Promise<{} | undefined> {
		const email = this.getEmailFormVal();
		const endpoint = this.getSubmitEndpoint();
		const source = this.getSource();

		const response: {} | undefined = await MessageGearsService.submitEmail(
			jwtToken,
			endpoint,
			email,
			source
		);

		return response;
	}

	toggleSubmitDisplay(): void {
		this.addTextAnimation();
		this.addSuccessClass();
		this.changeToSuccessMsg();
	}

	addTextAnimation(): void {
		const delay = 300;
		const animationClass = "preAnimation";
		this.titleElem.classList.add(animationClass);
		setTimeout(() => {
			this.titleElem.classList.remove(animationClass);
		}, delay);
	}

	addSuccessClass(): void {
		const successClass = "hasSubmittedSuccess";
		this._element.classList.add(successClass);
	}

	changeToSuccessMsg(): void {
		const { successTitle = "", successSubtitle = "" } = this._element.dataset;
		const successTitleElem = this.titleElem.querySelector(
			"[data-element='title']"
		);
		const successSubtitleElem = this.titleElem.querySelector(
			"[data-element='subtitle']"
		);

		if (!successTitleElem || !successSubtitleElem) {
			throw new Error(
				"Element/s not found for selectors: .title [data-element='title'], .title [data-element='subtitle']"
			);
		}

		successTitleElem.innerHTML = successTitle;
		successSubtitleElem.innerHTML = successSubtitle;
	}

	getJWTReqItems(): {
		endpoint: string;
		payload: { username: number; password: string };
	} {
		const {
			jwtEndpoint: endpoint,
			accountId: accountIdString,
			apiKey: password
		} = this._element.dataset;

		if (!endpoint || !accountIdString || !password) {
			throw new Error(
				"Missing dependency for fetching JWT Token. Check jwtEndpoint, accountId, and/or apiKey fielids."
			);
		}
		const username = parseInt(accountIdString, 10);

		return { endpoint, payload: { username, password } };
	}

	getEmailFormVal(): string {
		const inputElem = this._element.querySelector(
			"input[name='email']"
		) as HTMLInputElement;

		if (!inputElem.value) {
			throw new Error(`No input value found for email field: ${inputElem}`);
		}

		return inputElem.value;
	}

	getSubmitEndpoint(): string {
		const { submitEndpoint: endpoint } = this._element.dataset;

		if (!endpoint) {
			throw new Error(
				"submit endpoint value not found. Check submit endpoint field. "
			);
		}

		return endpoint;
	}

	getSource(): string {
		const { source } = this._element.dataset;

		if (!source) {
			throw new Error("source field not populated. Check source field.");
		}

		return source;
	}
}

ComponentFactory.registerComponent("JoinEmailModule", JoinEmailModule);
